import React from 'react';
import { Text, Badge } from '@mantine/core';
import { useNavigate } from 'react-router';
import { TodoTask } from '../types';
import EventItemContainer from '../EventItem/EventItemContainer';
import { getTodoDetails } from '../helpers';
import { getPopupEventVendors } from './helpers';

type ConfirmEventAttendanceItemProps = {
  task: TodoTask;
};

const ConfirmEventAttendanceItem: React.FC<ConfirmEventAttendanceItemProps> = ({ task }) => {
  const navigate = useNavigate();
  const popupEventVendors = getPopupEventVendors(task);

  return (
    <>
      {popupEventVendors.map((event) => (
        <EventItemContainer
          key={event.id}
          id={event.popupEvent.id}
          onClick={() => navigate(`/dashboard/popup_upcoming/${event.id}`)}
        >
          <Text fw="bold" size="sm" tt="capitalize">
            {event.popupEvent.productType.toLowerCase()} Event
          </Text>
          <Text size="sm" c="dimmed">
            {getTodoDetails(event)}
          </Text>
          <Badge size="sm" p="xs" color="yellow" radius="md" variant="light">
            Confirm Required
          </Badge>
        </EventItemContainer>
      ))}
    </>
  );
};

export default ConfirmEventAttendanceItem;
